enum StaticDocuments {
    EngineeringInsuranceInstructions = 'ENGINEERING_INSURANCE_INSTRUCTIONS'
};

export default StaticDocuments;